{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Mẫu",
    "DESCRIPTION": "Xem các mẫu tin nhắn được đồng bộ từ các hộp thư đến WhatsApp của bạn. Để tạo hoặc chỉnh sửa mẫu, hãy quản lý mẫu đó thông qua nhà cung cấp của bạn.",
    "COUNT": "{n} mẫu",
    "LEARN_MORE": "Tìm hiểu thêm về mẫu WhatsApp",
    "SYNC_TEMPLATES": "Đồng bộ mẫu",
    "SYNC_SUCCESS": "Đã bắt đầu đồng bộ mẫu cho tất cả hộp thư đến WhatsApp. Thay đổi có thể mất vài phút để cập nhật.",
    "PARTIAL_SYNC_ERROR": "Đã bắt đầu đồng bộ mẫu cho một số hộp thư đến WhatsApp, nhưng một số hộp thư khác không thể đồng bộ.",
    "SYNC_ERROR": "Không thể bắt đầu đồng bộ mẫu. Vui lòng thử lại.",
    "SEARCH_PLACEHOLDER": "Tìm kiếm theo nội dung hoặc tên...",
    "MANAGE_IN_META": "Quản lý trong Meta",
    "LOADING": "Đang tải mẫu WhatsApp...",
    "EMPTY": "Không tìm thấy mẫu WhatsApp nào.",
    "NO_RESULTS": "Không có mẫu nào khớp với bộ lọc của bạn.",
    "FETCH_ERROR": "Không thể tải mẫu WhatsApp. Vui lòng thử lại.",
    "PARTIAL_FETCH_ERROR": "Một số mẫu WhatsApp không thể tải được. Vui lòng thử lại.",
    "LAST_SYNC_ATTEMPT": "Lần đồng bộ gần nhất vào {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Chưa gửi để được WhatsApp phê duyệt"
    },
    "FILTERS": {
      "ALL_INBOXES": "Tất cả hộp thư đến",
      "ALL_LANGUAGES": "Tất cả ngôn ngữ",
      "ALL_TYPES": "Tất cả loại"
    },
    "TYPES": {
      "TEXT": "Văn bản",
      "IMAGE": "Hình ảnh",
      "VIDEO": "Video",
      "DOCUMENT": "Tài liệu",
      "CALL_TO_ACTION": "Kêu gọi hành động",
      "COPY_CODE": "Sao chép mã"
    },
    "PREVIEW": {
      "TITLE": "Xem trước mẫu",
      "DESCRIPTION": "Xem trước cách mẫu này hiển thị trên WhatsApp.",
      "OPEN": "Xem trước {name}",
      "CLOSE": "Đóng xem trước",
      "DETAILS": "Chi tiết mẫu",
      "STATUS": "Trạng thái",
      "TYPE": "Loại nội dung",
      "CATEGORY": "Danh mục",
      "LANGUAGE": "Ngôn ngữ",
      "INBOXES": "Hộp thư đến"
    }
  }
}
